export const ShipmentDialogStyle = {
  header: {
    display: "flex",
    // flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    width: "100%",
    position: "relative", // ×ボタン用
    paddingTop: 2,
    paddingBottom: 2,
  },
  closeButton: {
    position: "absolute",
    top: 20,
    right: 20,
    color: "#000",
    fontWeight: "bold",
    minWidth: 48,
    padding: "2px 8px",
    fontSize: "28px",
    lineHeight: 1,
  },
  footer: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    padding: 2,
    backgroundColor: "#fff",
    maxHeight: "300px", // ← 必要に応じて調整
    overflowY: "auto", // ← スクロール可能に
  },
  link: {
    cursor: "pointer",
    "&:hover": {
      color: "#1976d2",
      textDecoration: "underline",
    },
  },
};
